<template>
  <div class="qr-payment" :style="{ backgroundColor: backgroundColor }">
    <p>
      {{ setPayRemindText() }}
    </p>

    <div class="qr-container">
      <div ref="qrCode" class="qr-code"></div>
      <!-- <div>
        <qrcode-vue :value="CodeUrl" :size="150"></qrcode-vue>
      </div> -->
      <div class="countdown">
        {{ $i18n.t("subscription.pay_page_title_timer") }}
          {{ formatTime(timeLeft) }}
      </div>

      <div v-if="timeoutError" class="error-message">
        <h3>
          {{ $i18n.t("subscription.pay_page_title_pay_time_out") }}
        </h3>
        <p>
          {{ $i18n.t("subscription.pay_page_title_pay_time_out_notice") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import QRCode from 'qrcode';
import QrcodeVue from 'qrcode.vue'
import { PaymentType } from '@/store/modules/enums';

export default {
  name: 'QRCodePayment',
  components: {
    QrcodeVue
  },
  props: {
    CodeUrl: {
      type: String,
      required: true
    },
    OrderNo: {
      type: String,
      required: true
    },
    checkPaymentApi: {
      type: Function,
      required: true
    },
    PayMethod: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      CodeUrll: 'weixin://wxpay/bizpayurl?pr=mmxuZJzz1', // 用于存储二维码的URL
      timeLeft: 300, // 5分钟
      timer: null,
      checkTimer: null,
      timeoutError: false,
      remindText: this.$i18n.t("subscription.pay_page_title_pay_remind_txt_stripe"),
      backgroundColor: '#009FE7' // 默认背景色
    };
  },
  mounted() {
    // this.generateQRCode();
    this.startCountdown();
    this.startPaymentCheck();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    generateQRCode() {
      // 需要引入 QRCode 库
      if (typeof QRCode !== 'undefined') {
        this.$refs.qrCode.innerHTML = '';
        new QRCode(this.$refs.qrCode, {
          text: this.CodeUrl,
          width: 200,
          height: 200
        });
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          this.timeoutError = true;
          this.clearTimers();
          this.$emit('timeout');
        }
      }, 1000);
    },
    setPayRemindText() {
      return this.remindText;
    },
    startPaymentCheck() {
      this.checkTimer = setInterval(async () => {
        try {
          const status = await this.checkPaymentApi(this.OrderNo);
          if (status.data.Code === 0) {
            if (status.data.Result.Status === 2) {
              this.clearTimers();
              this.$emit('success');
            } else if (status.data.Result.Status === 1) {
              // 待支付
            } else if (status.data.Result.Status === 4) {
              // 订单已过期
              this.$message.warning('支付超时，请重新发起购买');
              this.$emit('timeout');
            }
          } else {
            // 其他状态处理
            console.error('查询状态出错:', status.data.Description);
          }
        } catch (error) {
          console.error('Payment check failed:', error);
        }
      }, 3000); // 3秒轮询一次
    },
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.checkTimer) {
        clearInterval(this.checkTimer);
        this.checkTimer = null;
      }
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.qr-payment {
  text-align: center;
  padding: 20px;
  color: #FFFFFF;
  font-size: 20px;
  margin-top: 30px;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.section-title {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
  text-align: center;
}

.qr-container {
  margin-top: 40px;
  text-align: center;
  padding: 10px;
  background-color: #FFFFFF;
  border-radius: 10px;
}

.qr-code {
  margin-bottom: 20px;
}

.countdown {
  font-size: 18px;
  color: #e74c3c;
  font-weight: bold;
  margin: 20px 0;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 5px;
  margin: 20px 0;
}
</style>